// extracted by mini-css-extract-plugin
export var wrapper = "icon-card-module--wrapper--1wPbW";
export var iconBox = "icon-card-module--icon-box--3fuAQ";
export var description = "icon-card-module--description--2m8BE";
export var link = "icon-card-module--link--_XSuJ";